<template>
    <a-modal
        class="Agreement"
        title=""
        @cancel="close"
        width="600px"
        v-if="isProtocolModalShow"
        :visible="true"
        :footer="null"
    >
        <div class="Agreement-content">
            <div class="Agreement-header">{{getLabel('TIP_PROTOCOL')}}</div>
            <div class="Agreement-body">
                <template v-if="protocolObj.id">
                    <div v-if="language==='zh'" v-html="protocolObj.zh_content"></div>
                    <div v-if="language==='en'" v-html="protocolObj.en_content"></div>
                </template>
            </div>
            <div class="Agreement-footer">
                <a-button @click="close">{{getLabel('TIP_CONFIRM')}}</a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
	import Language from '../util/language';
	import {mapState, mapGetters} from "vuex";

	export default {
		mounted() {
			if (!this.hasData) {
				this.$store.dispatch('protocol/getProtocol', () => {});
			}
		},
		computed: {
			...mapState({
				language: state => state.main.language,
				isProtocolModalShow: state => state.main.isProtocolModalShow,
				protocolObj: state => state.protocol.protocolObj,
				hasData: state => state.protocol.hasData
			}),
			...mapGetters('protocol', {
				protocolUrl: 'protocolUrl'
			})
		},
		methods: {
			// 获取描述
			getLabel: function (key) {
				return Language(this.language, key);
			},
			close: function () {
				this.$store.commit('main/setProtocolModalStatus', false);
			},
			download: function () {
				window.open(this.language === 'zh' ? this.protocolUrl.zh_url : this.protocolUrl.en_url);
			}
		}
	}
</script>

<style lang="less">
    .Agreement {
        &-content {
            width: 560px;
            margin: 0 auto;
            padding: 15px 0;
        }
        &-header {
            font-size: 16px;
            color: #333333;
        }
        &-body {
            padding: 13px 10px;
            border-top: 1px solid rgba(153, 153, 153, .3);
            border-bottom: 1px solid rgba(153, 153, 153, .3);
            margin-top: 13px;
            margin-bottom: 10px;
            max-height: 505px;
            overflow: auto;
        }
        &-footer {
            text-align: center;
        }
        .ant-modal-body {
            padding: 0;
        }
    }
</style>